"use strict";

export default {
  VORLAEUFIG: "b87c7ba7-10e8-4f56-8a0c-6d861d8bc218",
  AUSGELASSEN: "0d620ca3-feda-4386-89d5-3947bb7343d1",
  OFFEN: "9831b475-eb43-49bb-9d20-119dfa97fe73",
  ABGESCHLOSSEN: "b98c75f3-6306-4682-b87b-02de603cb6a1"
};
